const copy = {
  backToHome: "Back to home page",
  translationCallout: {
    description:
      "The Subject and Description fields of this ticket were translated because our support agents currently can only provide support in English.",
  },
  successDetails: {
    callout: {
      description: "Please check your email inbox for further instructions",
    },
    labels: {
      attachments: "Attachments",
      comment: "Description",
      email: "Email address",
      id: "Ticket ID#",
      priorityLevel: "Business impact",
      subject: "Subject",
    },
    title: "Your ticket has been submitted!",
  },
  errors: {
    page: {
      heading: "Looks like something isn't working",
      description: "Something went wrong. Try again later.",
      log: "Unable to load Ticket Submission due to priority level and/or CSRF error",
    },
    submission: "Something went wrong with ticket submission. Try again later.",
  },
};

export default copy;
